<template>
  <div class="contact-wrapper">
    <div class="bg">
      <img :src="require('@/assets/map.png')" alt="" class="bg-img" />
    </div>
    <div class="body">
      <h1 class="header">联系我们</h1>
      <div class="list" v-for="item in lists" :key="item.title">
        <img :src="item.icon" alt="" class="icon" />
        <span class="title">{{ item.title }}</span>
        <span class="desc">{{ item.desc }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {
      lists: [
        {
          icon: require("@/assets/icon_point.png"),
          title: "地址",
          desc: "杭州市西湖区天目山路398号",
        },
        {
          icon: require("@/assets/icon_phone.png"),
          title: "商务合作",
          desc: "13396571142",
        },
        {
          icon: require("@/assets/icon_email.png"),
          title: "商务合作",
          desc: "business@ooelicloud.com",
        },
        {
          icon: require("@/assets/icon_service.png"),
          title: "客服电话",
          desc: "0571-87978536",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.contact-wrapper {
  height: 600px;
  background: #2e2e2e;
  position: relative;
  .bg {
    display: flex;
    justify-content: center;
    height: 600px;
  }
  .bg-img {
    width: 2000px;
    height: 600px;
    object-fit:cover;
  }
  .body {
    position: absolute;
    left: 55%;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    .header {
      height: 34px;
      font-size: 24px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.949999988079071);
      line-height: 28px;
      margin-bottom: 16px;
    }
    .list {
      margin-bottom: 12px;
      display: flex;
      font-size: 14px;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 16px;
      }
      .title {
        font-weight: 400;
        color: rgba(255, 255, 255, 0.949999988079071);
        width: 72px;
        display: block;
      }
      .desc {
        color: rgba(255, 255, 255, 0.6499999761581421);
      }
    }
  }
}
</style>
